import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import PersonIcon from '@mui/icons-material/Person';
import LoginIcon from '@mui/icons-material/Login';
import ListItemButton from '@mui/material/ListItemButton';
import { Link, useLocation } from 'react-router-dom';
import PowerIcon from '@mui/icons-material/Power';
import PieChartIcon from '@mui/icons-material/PieChart';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button, Card, CardActions, Paper, Stack, useMediaQuery, useTheme, Tooltip } from '@mui/material';
import { GasMeter, GraphicEq, Grid3x3Outlined, NotificationsOutlined, Palette, PieChartSharp, SmartButton, SolarPower } from '@mui/icons-material'
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import MonitorIcon from '@mui/icons-material/Monitor';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SpaIcon from '@mui/icons-material/Spa';
import AllOutIcon from '@mui/icons-material/AllOut';
import ReportIcon from '@mui/icons-material/Report';
import AnchorIcon from '@mui/icons-material/Anchor';
import DetailsIcon from '@mui/icons-material/Details';
// import { AuthenticationContext } from '../../context/AuthenticationContext';
import { useState } from 'react';
import { useEffect } from 'react';
import Image from 'mui-image';

import ColorPaletteDialog from '../palette/ColorPaletteDialog';
import { LightTheme } from '../../Themes/MyTheme';
import { BusinessAuthenticationContext } from '../../context/BussinessAuthenticationContext';
import AlaramLog2 from '../../pages/admin/page/alarmLog2/AlarmLog2';
import { BusinessApi } from '../../api/Api';
import { SiSimpleanalytics } from "react-icons/si";
import { FaLayerGroup } from "react-icons/fa";




const drawerWidth = 200;
const collapsedWidth = 70;


function Header2({ isDrawerOpen, onToggleDrawer }) {

    const { LoggedInUserInfoIn, logOutIn } = React.useContext(BusinessAuthenticationContext)

    const { palette, spacing, breakpoints, shape: { borderRadius } } = useTheme()
    const [colorPaletteDialogOpen, setColorPaletteDialogOpen] = useState(false);

    const [showModal, setShowModal] = useState(false);

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [hasExpiryOrExpiringSoon, setHasExpiryOrExpiringSoon] = useState(false);




    const handleColorPaletteDialogOpen = () => {
        setColorPaletteDialogOpen(true);
    };

    const handleColorPaletteSelect = (colors) => {

        // updateThemeVariables(updatedThemeVariables);

    };

    const handleColorPaletteDialogClose = () => {
        setColorPaletteDialogOpen(false);
    };


    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);

    }; 


    // const { window } = props;
    const [currentTime, setCurrentTime] = useState(new Date());
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        // Clear the interval when the component is unmounted
        return () => clearInterval(intervalId);
    }, []); // Empty dependency array to run the effect only once on mount

    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const seconds = currentTime.getSeconds();
    const dates = currentTime.getDate()

    const year = currentTime.getFullYear();
    const month = currentTime.getMonth() + 1; // Months are 0-indexed
    const day = currentTime.getDate();

    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;


    const [open, setOpen] = useState(true);

    // const { logOutIn } = React.useContext(AuthenticationContext)
    // const { logOutIn } = React.useContext(AuthenticationContext)
    const [selectedIndex, setSelectedIndex] = useState(0);
    const location = useLocation()
    const laptopSize = useMediaQuery(breakpoints.down('xl'))
    const isLarge = useMediaQuery(breakpoints.up('xl'))
    const matchUpMd = useMediaQuery(breakpoints.up('lg'))

    // Close the drawer when the screen size is tablet
    useEffect(() => {
        if (laptopSize) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    }, [laptopSize])

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleDrawerToggle = () => {
        setOpen(!open);
    };


    const credentials = {
        LOGIN_ID:localStorage.getItem("business_LOGIN_ID") || "",
        SS_KEY: localStorage.getItem("business_SS_KEY") || "",
    };


    

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await BusinessApi(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);

                const today = new Date();
                const oneMonthLater = new Date();
                oneMonthLater.setMonth(today.getMonth() + 1);

                // Check if any date is expired or expiring within 1 month
                const shouldBlink = res.data.some(item => {
                    const expiry = new Date(item.subscription_expiry_date);
                    return expiry < today || expiry <= oneMonthLater;
                });

                setHasExpiryOrExpiringSoon(shouldBlink);
            } else {
                setLogData([]);
                setHasExpiryOrExpiringSoon(false);
            }
        } catch (err) {
            setError("Failed to fetch data. Please try again.");
            setHasExpiryOrExpiringSoon(false);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchLogData();
    }, [credentials.LOGIN_ID]);

    const drawer = (
        <Box
            color={'primary.light'}

            sx={{
                height: '100%',
                borderRight: 1,
                borderRightColor: 'lightgrey',
                bgcolor: 'lightgrey',


                flexGrow: 1,
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                    width: '8px',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#c1c1c1',
                    borderRadius: '4px',
                }
            }}>
                
            <Stack sx={{ pt: spacing(1) }} alignItems={'center'} rowGap={spacing(1)}>
                <Card>
                    <CardActions>
                        {/* <Image fit='contain' alt="Remy Sharp" src={require('../../assets/img/logos/logo 1.svg').default} /> */}
                        <Image
                            src={require('../../assets/img/logos/logo4.webp')}
                            alt="Logo"
                            style={{
                                width: 'auto',        // Adjust width automatically
                                height: '45px',       // Or whatever height fits your navbar
                                objectFit: 'contain', // Keep aspect ratio
                                backgroundColor: 'transparent', // Remove white background
                            }}
                        />
                    </CardActions>
                </Card>
                {/* <Typography variant='body1'>eSolar Plant Monitoring System</Typography> */}
                <Typography variant="body1" style={{ textAlign: 'center' }}>
                    {/* eSolar Plant Monitoring System */}
                </Typography>

            </Stack>

            <List
                sx={{
                    // selected and (selected + hover) states
                    '&& .Mui-selected, && .Mui-selected:hover': {
                        bgcolor: 'primary.light',
                        '&, & .MuiListItemIcon-root': {
                            color: 'background.default',
                        },
                    },
                    // hover states 
                    '& .MuiListItemButton-root:hover': {
                        bgcolor: 'primary.light',
                        '&, & .MuiListItemIcon-root': {
                            color: 'primary.main',
                        },
                        '&, & .ListItemText-root': {
                            color: 'background.default',
                        },
                    },

                }}

                component="nav" aria-label="main mailbox folders">


                <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/'}
                    LinkComponent={Link}
                    to='.'
                >
                    <ListItemIcon>
                        <PieChartIcon sx={{
                            fontSize: '1.3rem'
                        }} />
                    </ListItemIcon>
                    {open && <ListItemText primary="Dashboard" />}
                </ListItemButton>



                <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/plantMis'}
                    LinkComponent={Link}
                    to='plantMis'
                >
                    <ListItemIcon color='inherit'>
                        <SmartButton sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    {open && <ListItemText primary="Plant MIS" />}
                    {/* <ListItemText primary="Plant MIS" /> */}
                </ListItemButton>


                {
                    LoggedInUserInfoIn.GROUP_LIST === "1" && (

                        <ListItemButton
                            onClick={() => isLarge ? null : setOpen(false)}
                            selected={location.pathname === '/businessLocation'}
                            LinkComponent={Link}
                            to='businessLocation'
                        >
                            <ListItemIcon color='inherit'>
                                <AddLocationAltRoundedIcon sx={{ fontSize: '1.3rem' }} />
                            </ListItemIcon>
                            {open && <ListItemText primary="Geographical Location" />}
                        </ListItemButton>

                    )
                }


                {
                    LoggedInUserInfoIn.GROUP_LIST === "1" && (

                        <ListItemButton
                            onClick={() => isLarge ? null : setOpen(false)}
                            selected={location.pathname === '/businessGroupList'}
                            LinkComponent={Link}
                            to={'businessGroupList'}
                        >
                            <ListItemIcon color='inherit'>
                                <FaLayerGroup sx={{ fontSize: '1.4rem' }} />
                            </ListItemIcon>
                            {open && <ListItemText primary="Group List" />}
                            {/* <ListItemText primary="Group List" /> */}
                        </ListItemButton>

                    )
                }


                <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/businessWms'}
                    LinkComponent={Link}
                    to={'businessWms'}
                >
                    <ListItemIcon color='inherit'>
                        <SpaIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    {open && <ListItemText primary="WMS" />}
                    {/* <ListItemText primary="Group List" /> */}
                </ListItemButton>


                <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/analytics'}
                    LinkComponent={Link}
                    to={'analytics'}
                >
                    <ListItemIcon color='inherit'>
                        <SiSimpleanalytics sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Analytics" />
                </ListItemButton>

                {/* {
                    LoggedInUserInfoIn.GROUP_LIST === "1" && (
                        <ListItemButton
                            onClick={() => isLarge ? null : setOpen(false)}
                            selected={location.pathname === '/controllingGroup'}
                            LinkComponent={Link}
                            to={'controllingGroup'}
                        >
                            <ListItemIcon color='inherit'>
                                <SolarPower sx={{ fontSize: '1.3rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="Controlling Group" />
                        </ListItemButton>
                    )
                } */}






                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/grid'}
                    LinkComponent={Link}
                    to={'grid'}
                >
                    <ListItemIcon color='inherit'>
                        <Grid3x3Outlined sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Grid" />
                </ListItemButton> */}


                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/dg'}
                    LinkComponent={Link}
                    to={'dg'}
                >
                    <ListItemIcon color='inherit'>
                        <GraphicEq sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="DG" />
                </ListItemButton> */}

                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/energy-meter'}
                    LinkComponent={Link}
                    to={'energy-meter'}
                >
                    <ListItemIcon color='inherit'>
                        <GasMeter sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Energy Meter" />
                </ListItemButton> */}

                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/smb'}
                    LinkComponent={Link}
                    to={'smb'}
                >
                    <ListItemIcon color='inherit'>
                        <SmartButton sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="SMB" />
                </ListItemButton> */}

                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/analysis'}
                    LinkComponent={Link}
                    to={'analysis'}
                >
                    <ListItemIcon color='inherit'>
                        <AnalyticsIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Analysis" />
                </ListItemButton> */}


                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/pv_monitoring'}
                    LinkComponent={Link}
                    to={'pv_monitoring'}
                >
                    <ListItemIcon>
                        <MonitorIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="PV Monitoring" />
                </ListItemButton> */}

                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/wms'}
                    LinkComponent={Link}
                    to={'wms'}
                >
                    <ListItemIcon>
                        <SpaIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="WMS" />
                </ListItemButton> */}

                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/energy-reporting'}
                    LinkComponent={Link}
                    to={'energy-reporting'}
                >
                    <ListItemIcon>
                        <ReportIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Energy Reporting" />
                </ListItemButton> */}


                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/business'}
                    LinkComponent={Link}
                    to={'business'}
                >
                    <ListItemIcon>
                        <ReportIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Business_Dashboard" />
                </ListItemButton> */}



                {/* <ListItemButton
                    onClick={() => credentials.MNU_WMS === "0" ? setOpen(true) : setOpen(false)}
                    selected={location.pathname === '/wms'}
                    LinkComponent={Link}
                    to={'/wms'}

                >
                    <ListItemIcon>
                        <SpaIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="WMS" />
                </ListItemButton> */}

                {/* {
                    LoggedInUserInfoIn.MNU_WMS === "0" && (
                        <ListItemButton
                            onClick={() => setOpen(true)}
                            selected={location.pathname === '/wms'}
                            component={Link}
                            to={'/wms'}
                        >
                            <ListItemIcon>
                                <SpaIcon sx={{ fontSize: '1.3rem' }} />
                            </ListItemIcon>
                            <ListItemText primary="WMS" />
                        </ListItemButton>
                    )
                } */}





                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/event-log-reports'}
                    LinkComponent={Link}
                    to={'event-log-reports'}
                >
                    <ListItemIcon>
                        <AnchorIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Event Log Reports" />
                </ListItemButton> */}


                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/msit'}
                    LinkComponent={Link}
                    to={'msit'}
                >
                    <ListItemIcon>
                        <AnchorIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="MSIT" />
                </ListItemButton> */}




                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/plant-total-power-curve'}
                    LinkComponent={Link}
                    to={'plant-total-power-curve'}
                >
                    <ListItemIcon>
                        <PowerIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Plant Total Power Curve" />
                </ListItemButton> */}

                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/outage'}
                    LinkComponent={Link}
                    to={'outage'}
                >
                    <ListItemIcon>
                        <AllOutIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="Outage" />
                </ListItemButton> */}


                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/user-details'}
                    LinkComponent={Link}
                    to={'user-details'}
                >
                    <ListItemIcon>
                        <PersonIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="User Details" />
                </ListItemButton> */}



                {/* <ListItemButton
                    onClick={() => isLarge ? null : setOpen(false)}
                    selected={location.pathname === '/user-inform'}
                    LinkComponent={Link}
                    to={'user-info'}
                >
                    <ListItemIcon>
                        <PersonIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    <ListItemText primary="User Info" />
                </ListItemButton> */}


                <ListItemButton
                    onClick={() => logOutIn()}
                >
                    <ListItemIcon>
                        <LoginIcon sx={{ fontSize: '1.3rem' }} />
                    </ListItemIcon>
                    {/* <ListItemText primary="Logout" /> */}
                    {open && <ListItemText primary="Logout" />}
                </ListItemButton>


            </List>

        </Box>
    );

    return (
        <>
            <Box sx={{ display: "flex" }}>
                <CssBaseline />

                {/* App Bar */}
                <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                    <Toolbar>

                        {/*
                         <IconButton
                            aria-label="open drawer"
                            onClick={() => onToggleDrawer(!isDrawerOpen)}
                            edge="start"
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton> 
                        */}

                        <IconButton
                            aria-label="open drawer"
                            // onClick={open ? handleDrawerClose : handleDrawerOpen}
                            onClick={handleDrawerToggle}
                            edge="start"
                            color='inherit'
                        >
                            <MenuIcon />
                        </IconButton>

                        <Typography flexGrow={1} component="div" sx={{ pl: spacing(1), display: "flex", columnGap: spacing(1), alignItems: "center" }}>
                            <PieChartSharp sx={{ fontSize: '1.3rem' }} />
                            <Typography variant="h5"> eSolar Plant Monitoring System</Typography>
                        </Typography>

                        <Box direction={'row'} alignItems={'center'} justifyContent={'flex-end'}>

                            <Box flex={1} display={'flex'} alignItems={'center'}>

                                {/* Timing */}

                                <Box flex={1} sx={{ display: { sm: 'none', xs: 'none', md: 'none', lg: 'flex', xl: 'flex' } }} columnGap={spacing(1)} alignItems={'center'}>
                                    <Typography variant="body2" noWrap> {dates} / {month} / {year} </Typography>
                                    <Stack p={spacing(1)} component={Card} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                        <Typography noWrap variant='body2' textAlign={'center'}>
                                            {formattedHours}:{minutes < 10 ? `0${minutes}` : minutes}:
                                            {seconds < 10 ? `0${seconds}` : seconds}
                                        </Typography>
                                        <Typography variant='body2'> {ampm}</Typography>
                                    </Stack>
                                </Box>

                                {/* Timing */}
                                {/* <IconButton size='small' color='inherit'>
                                <NotificationsOutlined />
                            </IconButton> */}


                                <IconButton
                                    size="small"
                                    sx={{
                                        color: hasExpiryOrExpiringSoon ? 'red' : 'inherit',
                                        animation: hasExpiryOrExpiringSoon ? 'blink 1s infinite' : 'none'
                                    }}
                                    onClick={handleOpenModal}
                                >
                                    <NotificationsOutlined />
                                </IconButton>







                                {/* <Paper>
                                   
                                    <Image
                                        src={require('../../assets/img/logos/logo4.webp')}
                                        alt="Logo"
                                        style={{
                                            width: 'auto',        // Adjust width automatically
                                            height: '29px',       // Or whatever height fits your navbar
                                            objectFit: 'contain', // Keep aspect ratio
                                            backgroundColor: 'transparent', // Remove white background
                                        }}
                                    />
                                </Paper> */}

                                <IconButton color='inherit' onClick={handleColorPaletteDialogOpen}>
                                    <Palette />
                                </IconButton>


                                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        startIcon={<LoginIcon sx={{ fontSize: '1.3rem' }} />}
                                        variant="contained"
                                        color="primary"

                                        onClick={() => {
                                            console.log("Logout button clicked");
                                            logOutIn();
                                        }}

                                    >

                                        Logout
                                    </Button>
                                </Box>


                            </Box>
                        </Box>

                    </Toolbar>
                </AppBar>

                {/* Sidebar Drawer */}

                {/* <Drawer
                    variant="persistent"
                    open={isDrawerOpen}
                    sx={{
                        width: isDrawerOpen ? drawerWidth : 0,
                        flexShrink: 0,
                        transition: "width 0.3s ease-in-out",
                        [`& .MuiDrawer-paper`]: {
                            width: isDrawerOpen ? drawerWidth : 0,
                        },
                    }}
                >
                    <Toolbar />
                    {drawer}
                </Drawer> */}

                {/* <Drawer
                    variant="persistent"
                    open={true} // Always open
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        transition: "width 0.3s ease-in-out",
                        [`& .MuiDrawer-paper`]: {
                            width: drawerWidth,
                        },
                    }}
                >
                    <Toolbar />
                    {drawer}
                </Drawer> */}

                <Drawer
                    variant="permanent"
                    open={open}
                    sx={{
                        width: open ? drawerWidth : collapsedWidth,
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: open ? drawerWidth : collapsedWidth,
                            overflowX: "hidden",
                            transition: "width 0.3s",
                        },
                    }}
                >
                    <Toolbar />
                    {drawer}
                </Drawer>




                <ColorPaletteDialog
                    open={colorPaletteDialogOpen}
                    onClose={handleColorPaletteDialogClose}
                    onSelectColors={handleColorPaletteSelect}
                />

            </Box>

            {showModal && (
                <AlaramLog2
                    show={showModal}
                    handleClose={handleClose}

                />
            )}
        </>
    );
}

export default Header2;
